<div class="text-center" style="color: #ffffff; margin-top: 12px;">
    <p>
        <a href="https://leadcarrot.io" target="_top">leadcarrot.io</a>
    </p>
</div>